import { TaskInternalExternal } from '@gcv/shared';

import type { FilterListChild } from 'ui';
import { filterUtil } from 'util/filter.util';
import { searchUtil } from 'util/search.util';
import type { TaskRow } from '../../tasks/tasks.model';

// 'None' filter options are stored under their own value but match a '--' cell.
const NONE_FILTER_VALUES = new Set(['assignee_none', 'account_none']);

const SEARCHABLE_COLUMNS: (keyof TaskRow)[] = [
  'taskName',
  'assignee',
  'assigneeNames',
  'account',
  'accountNames',
  'associatedWith',
  'created',
  'createdBy',
  'dueDate'
];

export interface TaskRowFilters {
  filters: FilterListChild[];
  searchTerm: string;
  showAutogen: boolean;
  taskDirection: TaskInternalExternal;
}

export const getFilteredTaskRows = (rows: TaskRow[], options: TaskRowFilters): TaskRow[] => {
  const { filters, searchTerm, showAutogen, taskDirection } = options;
  const isInternal = taskDirection === TaskInternalExternal.INTERNAL;

  const filterTerms = filters.map((filter) => ({
    ...filter,
    value: NONE_FILTER_VALUES.has(filter.value) ? '--' : filter.value
  }));

  // The external table has no assignee column to search.
  const searchableColumns = isInternal
    ? SEARCHABLE_COLUMNS
    : SEARCHABLE_COLUMNS.filter((column) => column !== 'assigneeNames');

  let filteredRows: TaskRow[] = [];
  filterUtil<TaskRow>((result) => (filteredRows = result), rows, filterTerms);
  searchUtil<TaskRow>((result) => (filteredRows = result), filteredRows, searchableColumns, searchTerm);

  if (isInternal && !showAutogen) {
    return filteredRows.filter((row) => row.createdBy !== 'Auto Generated');
  }

  return filteredRows;
};
